/**
 * Global DOM patch to prevent React crashes caused by Google Translate.
 *
 * When Google Translate translates a webpage, it mutates the DOM tree by wrapping
 * text nodes into <font> tags. When React subsequently updates or unmounts,
 * native removeChild or insertBefore calls fail because child.parentNode !== this.
 *
 * This safe polyfill intercepts those calls and prevents the fatal DOMException:
 * "NotFoundError: Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node."
 */

if (typeof window !== 'undefined' && typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child && child.parentNode !== this) {
      if (typeof console !== 'undefined' && console.warn) {
        console.warn('Google Translate DOM discrepancy intercepted in removeChild:', child, this);
      }
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      if (typeof console !== 'undefined' && console.warn) {
        console.warn('Google Translate DOM discrepancy intercepted in insertBefore:', referenceNode, this);
      }
      return newNode;
    }
    return originalInsertBefore.apply(this, arguments);
  };
}

const isPatched = true;
export default isPatched;
